module.exports = __webpack_public_path__ + "static/img/4.7132924.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/4.jpg
// module id = 30jR
// module chunks = 1